<template>
  <div class="home">
    <!-- 导航 -->
    <div class="common_wrap">
      <div class="common_header_step">
        <img src="../assets/images/img_31.png" @click="goBack">
        <span>留存任务</span>
      </div>
      <div class="common_head_tips">
        <div class="step flex"><img src="https://static.cattryapp.com/12static/new/img/common_step1.png"> <i>打开应用</i>
        </div>
        <div class="step flex"><img src="https://static.cattryapp.com/12static/new/img/common_step2.png">
          <i>根据页面提示进行操作</i></div>
        <div class="step flex"><img src="https://static.cattryapp.com/12static/new/img/common_step3.png"> <i>领取奖励</i>
        </div>
      </div>
    </div>
    <!-- 小提示 -->
    <div class="task_head_tips ">
      <div class="left_msg ">
        <img src="https://static.cattryapp.com/12static/new/img/common_thorw.png">
        <span>留存任务</span>
      </div>
    </div>
    <!-- 任务 -->
    <div v-if="isHasList">
      <div class="common_item flex_btn_center" v-for="(item,index) in deepinsData" :key="index">
        <div class="left_msg flex">
          <img src="https://static.cattryapp.com/12static/new/img/common_thorw.png" alt="">
          <div class="word_msg">
            <h2>{{item.adname}}</h2>
            <div class="ret_msg">
              +{{item.price_tuser}}<i>元</i></div>
          </div>
        </div>
        <div class="btn" v-if='item.isOpen===0' @click='openapp(item)'>打开应用</div>
        <div class="btn canlingjiang" v-else-if='item.isOpen===1' @click='activetask(item)'>领取奖励</div>
      </div>
    </div>
      <!-- 暂无留存任务 -->
      <div class="nothing" v-if="!isHasList">
          <img src="https://static.cattryapp.com/12static/new/img/help_task_qs06.png">
          <!-- <span>暂无任务</span> -->
      </div>
  </div>
</template>

<script>
  import clientApi from '../assets/js/clientApi.js';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        deepinsData: [],
        osversion: 0,
      }
    },
    methods: {
      init() {
        this.$loading(true);
        this.$http.GETS('fast_task/belongTaskList', {}, (res) => {
          const {
            data
          } = res
          this.deepinsData = data.taskBelong
          this.osversion = data.iosVer
        })
      },
      getdeepinlist(item) {
        const {
          task_main_id: task_id,
          idfa,
          boundid,
          tuser_belongs_id
        } = item
        this.$http.POSTS('fast_task/belongTaskOpenApp', {
          task_id,
          idfa,
          boundid,
          tuser_belongs_id
        }, (res) => {
          this.init()
        })
      },
      // 打开应用
      openapp(item) {
        if (this.osversion > 11) { //ios12以上
          clientApi.ios11openurl({bundleid: item.boundid}).then((response) => {
            if (response.data == 1) { //已安装

              this.getdeepinlist(item);

            } else { //未安装或不确定是否安装
              Dialog.confirm({
                  title: '温馨提示',
                  message: '您的应用已经删除,请重新下载打开',
                })
                .then(() => {
                  // on confirm
                  window.location.href = item.appstore_url;
                })
                .catch(() => {
                  // on cancel
                  // window.location.href = item.lpg;
                });
            }
          }).catch((err) => {
            Dialog.alert({
              title: '提示',
              message: '网络错误...',
            })
          })
        } else { //非ios 11
          
          clientApi.checktaskinstall({bundleid: item.boundid})
            .then((response) => {
              if (response.data == 1) {
                clientApi.ios11openurl(data).then((response) => {
                  this.getdeepinlist(item);
                })
              } else {
                Dialog.confirm({
                    title: '温馨提示',
                    message: '您的应用已经删除,请重新下载打开',
                  })
                  .then(() => {
                    // on confirm
                    window.location.href = item.appstore_url;
                  })
                  .catch(() => {
                    // on cancel
                    // window.location.href = item.lpg;
                  });
              }
            }).catch((err) => {
              Dialog.alert({
                title: '提示',
                message: '网络错误...',
              })
            });
        }
      },
      // 领奖
      activetask(item) {
        const {
          idfa,
          boundid,
          tuser_belongs_id
        } = item
        this.$http.POSTS('fast_task/taskBelongsActive', {
          idfa,
          boundid,
          tuser_belongs_id
        }, (res) => {
          if (res.data.success === 1) {
            this.$toast('领奖成功')
            this.init()
          }
        })
      },
      goBack() {
        this.$router.go(-1)
      }
    },
    created() {
      this.init()
    },
    computed: {
      isHasList() {
        return this.deepinsData && (this.deepinsData.length > 0)
      }
    }
  }
</script>

<style lang="less" scoped>
  .home {
    display:flex;
    flex-direction: column;
    height: 100%;
  }
  .common_wrap {
    width: 100%;
    /* background: linear-gradient(124deg, #ff7757, #f63b53); */
    background: #ea323c;
    box-sizing: border-box;
  }

  .common_header_step {
    position: relative;
    height: 45px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    color: #fff;
    font-size: 18px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    box-sizing: border-box;

    img {
      position: absolute;
      left: 5px;
      z-index: 10;
      width: 10px;
      height: 17px;
      padding: 7px 11px;
    }
  }

  .common_head_tips {
    padding: 0 35px 13px 35px;
    display: flex;
    justify-items: center;
    align-items: center;
    box-sizing: border-box;

    .step {
      font-size: .857rem;
      font-family: PingFangSC-Regular;
      color: #fff;
      display: flex;
      align-items: center;
      line-height: .928rem;

      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      i {
        line-height: 12px;
        font-size: 12px;
        color: #fff;
        margin-right: 6px;
        font-style: normal;
      }
    }
  }

  .task_head_tips {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    width: 100%;
    height: 39px;
    background: #fff;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f1;

    .left_msg {
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      color: #666;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
    }
  }

  .common_item {
    color: #3f4552;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    list-style-type: none;
    vertical-align: baseline;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 68px;
    border-bottom: 1px solid #f1f1f1;
    background: #ffffff;
    padding: 0 16px;
    box-sizing: border-box;

    .left_msg {
      display: flex;
      color: #3f4552;
      margin: 0;
      padding: 0;
      border: 0;
      align-items: center;

      img {
        color: #3f4552;
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        width: 45px;
        height: 45px;
        border-radius: 6px;
        margin-right: 10px;
      }

      .word_msg {
        display: flex;
        flex-direction: column;
        justify-content: center;
        /* align-items: center; */
        color: #3f4552;
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 14px;

        h2 {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333;
          line-height: 16px;
          margin-bottom: 6px;
          width: 180px;
        }

        .ret_msg {
          margin: 0;
          padding: 0;
          border: 0;
          font-size: 18px;
          font-family: HelveticaNeue-Medium;
          font-weight: 500;
          color: #ff6353;

          i {
            font-style: normal;
            font-size: 14px;
          }
        }
      }
    }

    .btn {
      /* flex: 1/3; */
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100px;
      height: 30px;
      flex-shrink: 0;
      background: #5192f5;
      border-radius: 22px;
      color: #fff;
      font-size: 16px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
    }

    .canlingjiang {
      background: #ff6353;
    }

    .finnish {
      background: #909399;
    }
  }
  .nothing {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: 20px;
    color: #999999;
  }
</style>